import {
  initialState,
  Actions,
  State,
  EDIT_RESPONSIBLE,
  EDIT_RESPONSIBLE_SUCCESS,
  EDIT_RESPONSIBLE_ERROR,
  RESET_EDIT_RESPONSIBLE,
} from '../../types/responsible/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_RESPONSIBLE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_RESPONSIBLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_RESPONSIBLE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_RESPONSIBLE:
      return initialState
    default:
      return state
  }
}

export default reducers
